(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["classic-gallery-lightbox"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const section = document.currentScript?.closest('.shopify-section');
    if (!(section instanceof HTMLElement)) return;

    const dialog = section.querySelector('[data-gallery-dialog]');
    const dialogImage = section.querySelector('[data-gallery-image]');
    if (!(dialog instanceof HTMLDialogElement) || !(dialogImage instanceof HTMLImageElement)) return;

    section.addEventListener('click', (event) => {
      const target = event.target instanceof Element ? event.target.closest('[data-gallery-open]') : null;
      if (!(target instanceof HTMLElement)) return;

      const src = target.getAttribute('data-gallery-src');
      if (!src) return;

      const alt = target.getAttribute('data-gallery-alt') || '';
      dialogImage.src = src;
      dialogImage.alt = alt;
      dialog.showModal();
    });

    section.addEventListener('click', (event) => {
      const close = event.target instanceof Element ? event.target.closest('[data-gallery-close]') : null;
      if (!close) return;
      dialog.close();
    });

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) {
        dialog.close();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
